import api from '../';

class vocabularyMemoGameApi {
    static getItemsByRequest(params) {
        return api.axios.get('/vocabulary-memo/items', { params }).then(response => response.data.items);
    }
}

export default vocabularyMemoGameApi;
